import { createFileRoute } from "@tanstack/react-router";
import AdminPage from "lib/components/admin/builders/AdminPage";
import BuilderHeader from "lib/components/builders/BuilderHeader";
import PlanPicker from "lib/components/demo/PlanPicker";
import { useAppRouterParams } from "lib/routeHelpers";
import ProductCard, { ProductCards } from "ui/cards/ProductCard";
import withAuthentication from "../../../components/withAuthentication";
import styles from "./index.module.scss";

function ConnectedExperience() {
  const { builderId, locationPlanId } = useAppRouterParams();
  return (
    <AdminPage currentPage="debug" pageTitle="Connected Experience">
      <BuilderHeader header="Connected Experience" />
      <div className={styles.adminPageWrapper}>
        <PlanPicker className={styles.adminPage}>
          <ProductCards>
            <ProductCard
              title="IBS 2024 Demo"
              subtitle="Showroom, Procure, and Live Sheets"
              ctaText="Launch"
              href={`/demo/connected/showroom?builderId=${builderId}&planId=${locationPlanId}`}
            />
            <ProductCard
              title="IBS 2024 Demo (Lite)"
              subtitle="Without the fuzzer, in case unstable"
              ctaText="Launch"
              href={`/demo/connected/showroom?fuzzer=0&builderId=${builderId}&planId=${locationPlanId}`}
            />
            <ProductCard
              title="Individual Tabs"
              subtitle="Open Showroom, Procure, and Live Sheets in new tabs"
              ctaText="Launch"
              href={`/demo/connected/tabs?builderId=${builderId}&planId=${locationPlanId}`}
            />
            <ProductCard
              title="Single Screen Demo"
              subtitle="Connected Experience in one screen"
              ctaText="Launch"
              href={`/demo/connected/singlescreen?builderId=${builderId}&planId=${locationPlanId}`}
            />
          </ProductCards>
        </PlanPicker>
      </div>
    </AdminPage>
  );
}

export const Route = createFileRoute("/demo/connected/")({
  component: withAuthentication(ConnectedExperience, { superAdmin: true }),
});
